import React, { useEffect } from 'react';
import { HeaderFlexWrap, TitleFlexWrap } from '../styled';
import TrendSelector from './TrendSelector';
import { unitAtom, isTableCompareEnabledAtom } from '../atoms';
import { useAtomValue, useSetAtom } from 'jotai';
import { tid } from '@utils/test';
import MetricTags from './MetricTags';
import { useTrendsFilterPanelHeight } from '@src/atoms/page-styles';

const DimensionHeader = ({ disableOrderBySelector = false, disableMetricTags = false }) => {
  const setUnit = useSetAtom(unitAtom);
  const isTableCompareEnabled = useAtomValue(isTableCompareEnabledAtom);
  const filterPanelHeight = useTrendsFilterPanelHeight();

  useEffect(() => {
    if (isTableCompareEnabled) {
      setUnit('%');
    }
  }, [isTableCompareEnabled, setUnit]);

  return (
    <HeaderFlexWrap {...tid('controls')} $top={filterPanelHeight}>
      <TitleFlexWrap>
        {!disableOrderBySelector && <TrendSelector />}
        {!disableMetricTags && <MetricTags />}
      </TitleFlexWrap>
    </HeaderFlexWrap>
  );
};

export default DimensionHeader;
